import { ready, onShopifySectionLoad } from './utils/readyinit';
import { initSwiper, initSwiperMobile } from './components/swiper';
import initAccordion from './components/accordion';
import initLazyloadVideo from './utils/lazyloadVideo';
import initHeader from './sections/header/header';
import initCustomDropdowns from './components/custom-dropdowns';
import initMinicart from './components/minicart';
import initAtcForm from './components/atcForm';
import initTabsSections from './sections/tabs-section';
import initMobileVariantPicker from './components/mobile-variant-picker';
import initProductCardVariants from './components/product-card-variants';
import initFrequentlyBoughtTogether from './sections/frequently-bought-together';
import initOkendoReviews from './sections/okendo-reviews';
import initBlogPostProductCard from './sections/blog-post-product-card';
import initBlogPostRelated from './sections/blog-post-related';
import initFaqs from './sections/faqs';
import initVimeoInlineVideo from './sections/vimeo-inline-video';

ready(() => {
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initMinicart();
  initMobileVariantPicker();
  initHeader();
  initAccordion();
  initLazyloadVideo();
  initAtcForm();
  initTabsSections();
  initProductCardVariants();
  initFrequentlyBoughtTogether();
  initOkendoReviews();
  initBlogPostProductCard();
  initBlogPostRelated();
  initFaqs();
  initVimeoInlineVideo();
});

onShopifySectionLoad(() => {
  initSwiper();
  initSwiperMobile();
  initCustomDropdowns();
  initHeader();
  initLazyloadVideo();
  initMinicart();
  initMobileVariantPicker();
  initAtcForm();
  initTabsSections();
  initProductCardVariants();
  initFrequentlyBoughtTogether();
  initOkendoReviews();
  initBlogPostProductCard();
  initBlogPostRelated();
  initFaqs();
  initVimeoInlineVideo();
});
